<script lang="ts" setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useDisplay } from 'vuetify';
import useReaderStore from '../../stores/reader';
import useLocale from '../../composables/useLocale';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLocationCrosshairs } from '@fortawesome/pro-solid-svg-icons';

library.add(faLocationCrosshairs);

type Props = {
  hasMediaAvailable: boolean;
};

const props = defineProps<Props>();
const value = defineModel<boolean>({ required: true });
const { t } = useLocale();
const { smAndDown } = useDisplay();
const { isContinuous } = storeToRefs(useReaderStore());

const isAvailable = computed(() => isContinuous.value && props.hasMediaAvailable);
</script>

<template>
  <v-list-item
    v-if="isAvailable"
    density="compact"
    data-testid="bp-setting-auto-follow-playback"
    :title="t('book_player.label_auto_follow_playback')"
  >
    <template #prepend>
      <FontAwesomeIcon class="pr-3" :size="!smAndDown ? 'xl' : 'lg'" icon="fa-solid fa-location-crosshairs" />
    </template>
    <template #append>
      <v-switch v-model="value" class="pl-4" color="primary" hide-details inset />
    </template>
  </v-list-item>
</template>

<style scoped lang="scss">
:deep(.v-switch__track) {
  opacity: 1;
}
:deep(.v-icon) {
  opacity: 1 !important;
}
:deep(.v-switch .v-switch__track) {
  background-color: rgb(var(--v-theme-secondary));
}
</style>
